import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import Cookie from 'js-cookie';
import store from "@/store/index.js";
// 401拦截
var resp401 = {
  /**
   * 响应数据之前做点什么
   * @param response 响应对象
   * @param options 应用配置 包含: {router, i18n, store, message}
   * @returns {*}
   */
  onFulfilled: function onFulfilled(response, options) {
    // console.log(response)
    //如果允许关闭请求loading（默认为true,可在请求参数中设置为false,以在回调中手动关闭），并且请求方法为POST和PUT时，关闭请求loading
    var message = options.message,
      notification = options.notification;
    var router = options.router;
    var _response$data = response.data,
      status = _response$data.status,
      code = _response$data.code;
    if (code === 401) {
      message.config({
        maxCount: 1
      });
      message.error('登录超时,请重新登录');
      router.push('/login');
    }
    if (code === 401) {} else if (code === 403) {
      message.warning(response.data.message);
    } else if (code === 400) {
      notification.error({
        message: response.data.message
      });
    } else if (code === 500) {
      notification.error({
        message: response.data.message
      });
    }
    store.state.setting.loadding = false;
    try {
      if (response.config.data && JSON.parse(response.config.data).allowCloseReqLoading && (response.config.method.toUpperCase() == "PUT" || response.config.method.toUpperCase() == "POST")) {
        store.state.reqLoading = false;
      }
    } catch (e) {
      store.state.reqLoading = false;
    }
    return response;
  },
  /**
   * 响应出错时执行
   * @param error 错误对象
   * @param options 应用配置 包含: {router, i18n, store, message}
   * @returns {Promise<never>}
   */
  onRejected: function onRejected(error, options) {
    var message = options.message;
    var response = error.response;
    if (error.toString().indexOf("timeout") >= 0) {
      message.error('连接超时，请重试~');
    } else if (response.status === 401) {
      message.error('无此权限');
    }
    return Promise.reject(error);
  }
};

// const resp403 = {
//   onFulfilled(response, options) {
//     console.log("403",response)
//     const {message} = options
//     if (response.code === 403) {
//       message.error('请求被拒绝')
//     }
//     return response
//   },
//   onRejected(error, options) {
//     const {message} = options
//     const {response} = error
//     if (response.status === 403) {
//       message.error('请求被拒绝')
//     }
//     return Promise.reject(error)
//   }
// }

var reqCommon = {
  /**
   * 发送请求之前做些什么
   * @param config axios config
   * @param options 应用配置 包含: {router, i18n, store, message}
   * @returns {*}
   */
  onFulfilled: function onFulfilled(config, options) {
    // console.log(config,options)
    //如果是POST或PUT请求，并且正在请求中，直接返回，否则将正在请求标识设置为true
    if (config.method.toUpperCase() == "POST" || config.method.toUpperCase() == "PUT") {
      if (store.state.reqLoading) {
        return config;
      }
      store.state.reqLoading = true;
    }
    //全局loadding
    store.state.setting.loadding = true;
    var message = options.message;
    var url = config.url,
      xsrfCookieName = config.xsrfCookieName;
    if (url.indexOf('login') === -1 && xsrfCookieName && !Cookie.get(xsrfCookieName)) {
      // message.warning('认证 token 已过期，请重新登录')
    }
    return config;
  },
  /**
   * 请求出错时做点什么
   * @param error 错误对象
   * @param options 应用配置 包含: {router, i18n, store, message}
   * @returns {Promise<never>}
   */
  onRejected: function onRejected(error, options) {
    var message = options.message;
    message.error(error.message);
    return Promise.reject(error);
  }
};
export default {
  request: [reqCommon],
  // 请求拦截
  response: [resp401] // 响应拦截
};